import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import api from '../utils/api'
import router from '../router'
Vue.use(router)

Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [
      // 默认存储在localStorage上
      createPersistedState({
          key: 'vuex', 
          // storage: 'window.localStorage'
      })
  ],
  state: {
    token: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC9zZXJ2aWNlLndvcm1ob28uY29tXC9cL2FwaVwvYXV0aFwvbG9naW4iLCJpYXQiOjE2NTAyNjAyMDgsImV4cCI6MTY2MDYyODIwOCwibmJmIjoxNjUwMjYwMjA4LCJqdGkiOiJXc3R4MXJETHJKREdRQXhMIiwic3ViIjo1MDIzNywicHJ2IjoiODdlMGFmMWVmOWZkMTU4MTJmZGVjOTcxNTNhMTRlMGIwNDc1NDZhYSJ9.O2efMrDNR4Dr0zTDdfA2b2n2GTGo6-tfw_nBYcIqjXg',
    user: '',
    headerActive: 'index',
    platMap: {},
    daojia_appid: 'wx7ee6265dbf8f90b0',
    chongdong_appid: 'wxb1d573e34d48cbf6',
    wx: {},
    plat: {},
    plat_id: 119,
    indexTab: [],
    indexTab2: [],
    vipInfo:null,
  },
  mutations: {
    // 重置一些直接在state里写死的值，以防止直接改state里的数据，浏览器缓存没有更新
    SET_INIT:(state,info)=>{
      state[info.name] = info.data
    },
    SET_VIP:(state,info)=>{
      state.vipInfo = info
    },
    SET_PLAT: (state, plat) => {
      state.plat = state.platMap[plat];
      state.plat_id = state.platMap[plat].id;
      document.title = state.platMap[plat].name;
      let faviconurl = state.platMap[plat].faviconurl;
      // var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
      // link.type = 'image/x-icon';
      // link.rel = 'shortcut icon';
      // link.href = faviconurl;
      // document.getElementsByTagName('head')[0].appendChild(link);
      console.log(faviconurl)
    },
    SET_HEADER_HEIGHT:  (state, plat) => {
      state.headerHeight = plat
    },
    SET_HEADER: (state, plat) => {
      console.log('setHeader',plat)
      state.headerActive = plat
    },
    setToken(state, payload) {
      console.log('setToken')
        state.token = payload;
    },
    setUser(state, payload) {
        state.user = payload
    },
    setWx(state, payload) {
        state.wx = payload;
    },
  },
  actions: {
    async tokenLogin(store, token) {
        store.commit('setToken', token);
        let res = await api({
            url: "/api/auth/me",
        });
        if (res.code == 0) {
            store.commit('setUser', res.data);
            store.commit('setWx', {
                openid: res.data.web_dj_openid,
                unionid: res.data.unionid
            });
        }
    },
    async getVIPInfo(store) {
      let res = await this.$api({
        // url: "/api/users/university/index",
        url: `/api/platform/pc/index?plat_id=${store.plat}&terminal=1`,
      });
     
      if (res.code == 0) {
        let {  plat_vip } = res.data;
        store.commit('SET_VIP',plat_vip)
      } 
    },
    jump(store,params){
        router.push(params)
    },
    reJump(store,params){
      router.push(params)
    },
    back(){
      router.go(-1)
    }
  },
  modules: {
  }
})
